import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { ConfirmationModals } from "../../activity_form.types";
import { useActivityFormStore } from "../../activity_form_store";
import { useActivityFormSubmit } from "./use_activity_form_submit";

export const useActivityFormAutoSubmit = () => {
  const modals = useActivityFormStore((state) => state.modals);
  const submitOptions = useActivityFormStore((state) => state.submitOptions);
  const submit = useActivityFormSubmit();
  const {
    formState: { isSubmitting }
  } = useFormContext();

  const isNoRequirementsModalConfirmed = modals[ConfirmationModals.NoRequirements].isConfirmed;
  const isMisalignmentModalConfirmed = modals[ConfirmationModals.Misalignment].isConfirmed;
  const isQuestionsChangedModalConfirmed = modals[ConfirmationModals.QuestionsChanged].isConfirmed;

  useEffect(
    () => {
      if (
        !isSubmitting &&
        (isNoRequirementsModalConfirmed || isMisalignmentModalConfirmed || isQuestionsChangedModalConfirmed)
      ) {
        submit(submitOptions);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isNoRequirementsModalConfirmed, isMisalignmentModalConfirmed, isQuestionsChangedModalConfirmed]
  );
};
